import React, {Component} from 'react';
import ViewRenderer from './views';
import {API} from '../../../requests';
import './styles.css';
import PopupContainer from '../../../components/PopupContainer';
import POPUP_CONSTANTS from '../../../constants/popup-constants';
import Spinner from '../../../components/Spinner';
import Popup from '../../../components/SimplePopup';
import strings from '../../../globalization';
import util from '../../../util';
import {getFormData} from './data';
import {editFormData} from './editData';
import DeletePopup from '../../../components/DeletePopup';
import PopupData from '../../../components/PopupPerson/popup';
import {operatorImages} from '../../../assets/images';

class VehicleType extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: undefined,

      searchText: '',
      vehicleType: [],
      filterVehicleType: [],
      selectedStatus: '',
    };
  }
  statuses = [
    {
      id: '',
      name: 'ALL',
    },
    {
      id: 'inactive',
      name: 'INACTIVE',
    },
    {
      id: 'active',
      name: 'ACTIVE',
    },
  ];
  updatedStatus = this.statuses.filter(elem => elem.id !== '');
  onSubmit = vehicleType => {
    const vehicleTypeData = {
      name: vehicleType.name.value,
      name_hindi: vehicleType.name_hindi.value,
    };

    this.saveVehicleType({
      ...vehicleTypeData,
      vehicleCategoryId: vehicleType.vehicleCategoryId.value,
    });
    this.setState({
      popup: null,
    });
  };
  showErrorPopup = errorMsg => {
    // crashlytics().recordError(new Error(errorMsg));

    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: errorMsg,
        messageStyle: {color: '#E67717'},

        buttons: [
          {
            text: strings.okayPopup,
            onClick: this.onClose,
          },
        ],
        onClose: this.closePopup,
      },
    });
  };
  fetchVehicleCategoryData = (action, data) => {
    API.fetchVehicleCategoryTableData()
      .then(res => {
        console.log('resdata', res.data);
        let newResponse = res.data.filter(elem => elem.status !== 'INACTIVE');
        if (action === 'add') {
          this.setState({
            popup: {
              type: POPUP_CONSTANTS.ADD_DATA_POPUP,
              vehicleCategories: newResponse,
            },
          });
        } else if (action === 'edit') {
          this.setState({
            popup: {
              type: POPUP_CONSTANTS.EDIT_POPUP,
              statuses: this.updatedStatus,
              vehicleCategories: newResponse,
              categoryTypeData: data,
            },
          });
        }
      })
      .catch(err => {
        const error = util.getErrorMessage(err);
        this.showErrorPopup(error);
      });
  };
  showSuccessPopup = (successMessage, onClick) => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: successMessage,
        onClose: this.onClose,
        headingImage: operatorImages.successIcon,
        buttons: [
          {
            text: strings.okayPopup,
            onClick: onClick ? onClick : this.onClose,
            outline: true,
          },
        ],
      },
    });
  };

  onClickHandler = (action, data) => {
    switch (action) {
      case 'edit': {
        this.fetchVehicleCategoryData(action, data);

        break;
      }
      case 'delete': {
        data.status === 'ACTIVE' &&
          this.setState({
            vehicleType: data,
            popup: {type: POPUP_CONSTANTS.DELETE_POPUP},
          });

        break;
      }
      default: {
        console.log('nahi match huya');
        break;
      }
    }
  };
  onClose = () => {
    this.setState({
      popup: null,
    });
  };
  tableActionHandler = (action, data) => {
    switch (action) {
      case 'status': {
        this.setState(
          {
            selectedStatus: data,
          },
          this.applyFilters,
        );
        break;
      }
      case 'shift': {
        break;
      }
      case 'add': {
        this.fetchVehicleCategoryData(action, data);
        break;
      }
      case 'search': {
        this.setState(
          {
            searchText: data,
          },
          this.applyFilters,
        );
        break;
      }
      case 'clearFilter': {
        this.setState({
          searchText: '',
          selectedStatus: '',
        });
        this.fetchVehicleType();
        break;
      }
      default: {
        console.info('filterChangeHandler case not handled', action);
      }
    }
  };
  applyFilters = () => {
    const {searchText, selectedStatus, vehicleType} = this.state;
    const filteredData =
      vehicleType.length > 0 &&
      vehicleType.filter(row => {
        if (
          searchText &&
          !Object.values({name: row.name, name_hindi: row.name_hindi})
            .toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
        ) {
          return false;
        }

        if (
          selectedStatus &&
          row.status.toLowerCase() !== selectedStatus.toLowerCase()
        ) {
          return false;
        }
        return true;
      });
    this.setState({
      filterVehicleType: filteredData,
    });
  };
  fetchVehicleType = () => {
    this.setState({popup: {type: POPUP_CONSTANTS.SPINNER_POPUP}});
    API.fetchVehicleTypeData()
      .then(res => {
        this.setState(
          {
            ...this.state,
            vehicleType: res.data,
            filterVehicleType: res.data,
            popup: null,
          },
          this.applyFilters,
        );
      })
      .catch(err => {
        const error = util.getErrorMessage(err);
        this.showErrorPopup(error);
      });
  };
  saveVehicleType = vehicleTypeName => {
    let formData = {
      name: vehicleTypeName.name,
      name_hindi: vehicleTypeName.name_hindi,
      vehicleCategoryId: vehicleTypeName.vehicleCategoryId,
    };
    this.setState({popup: {type: POPUP_CONSTANTS.SPINNER_POPUP}});
    API.saveVehicleTypeData(formData)
      .then(res => {
        this.showSuccessPopup(
          'Vehicle Type Added Successfully',
          this.fetchVehicleType,
        );
      })
      .catch(error => {
        const err = util.getErrorMessage(error);
        this.showErrorPopup(err);
      });
  };
  onDeleteHandler = () => {
    let id = this.state.vehicleType.id;
    this.deleteVehicleTypeData(id);
    this.setState({popup: null});
  };

  deleteVehicleTypeData = id => {
    this.setState({popup: {type: POPUP_CONSTANTS.SPINNER_POPUP}});
    API.deleteVehicleType(id)
      .then(res => {
        this.showSuccessPopup(
          'Vehicle Type Deleted Successfully',
          this.fetchVehicleType,
        );
      })
      .catch(error => {
        const err = util.getErrorMessage(error);
        this.showErrorPopup(err);
      });
  };
  updateVehicleTypeData = data => {
    this.setState({popup: {type: POPUP_CONSTANTS.SPINNER_POPUP}});
    API.updatesVehicleTypeData(data)
      .then(res => {
        this.showSuccessPopup(
          'Vehicle Type Updated Successfully',
          this.fetchVehicleType,
        );
      })
      .catch(error => {
        const err = util.getErrorMessage(error);
        this.showErrorPopup(err);
      });
  };
  onEditHandler = data => {
    let myData = {
      // id: this.state.vehicleType.id,
      id: data.id.value,
      name: data.name.value,
      name_hindi: data.name_hindi.value,
      status: data.status.value.toUpperCase(),
      vehicleCategoryId: data.vehicleCategoriesId.value,
    };
    this.updateVehicleTypeData(myData);
    this.setState({popup: null});
  };
  getProps = () => {
    const {searchText, filterVehicleType, selectedStatus} = this.state;
    return {
      onClick: this.onClickHandler,
      onChange: this.onChangeHandler,
      filterChangeHandler: this.tableActionHandler,
      vehicleType: filterVehicleType,
      statuses: this.statuses,
      searchText,
      selectedStatus,
    };
  };

  getPopupContent = () => {
    const {popup} = this.state;
    switch (popup.type) {
      case POPUP_CONSTANTS.ADD_DATA_POPUP: {
        return (
          <PopupData
            header="Add"
            // vehicleType={this.getvehicleType}
            onSubmit={this.onSubmit}
            onClose={this.onClose}
            // requiredName={this.state.requeredField}
            getFormData={getFormData}
            {...popup}
          />
        );
      }
      case POPUP_CONSTANTS.EDIT_POPUP: {
        return (
          <PopupData
            header="Edit"
            onSubmit={this.onEditHandler}
            onClose={this.onClose}
            // requiredName={this.state.requeredField}
            getFormData={editFormData}
            {...popup}
          />
        );
      }
      case POPUP_CONSTANTS.DELETE_POPUP: {
        return (
          <DeletePopup onClick={this.onDeleteHandler} onClose={this.onClose} />
        );
      }
      case POPUP_CONSTANTS.SPINNER_POPUP: {
        return <Spinner name="cube-grid" color="#0045E6" {...popup} />;
      }
      case POPUP_CONSTANTS.SIMPLE_POPUP: {
        return <Popup {...popup} />;
      }
      default: {
        console.warn('getPopupContent', popup.type);
        return null;
      }
    }
  };
  componentDidMount() {
    this.fetchVehicleType();
  }

  render() {
    const viewProps = this.getProps();
    const {popup} = this.state;
    return (
      <>
        {popup ? (
          <PopupContainer> {this.getPopupContent()} </PopupContainer>
        ) : null}
        <ViewRenderer {...viewProps} />
      </>
    );
  }
}

export default VehicleType;
